import React from 'react'
import connectProvider from 'gyl-common/hocs/connectProvider'
import FieldItemList from '../FieldItemList'
import SearchArea from '../SearchArea'
import Context, { ContextValueType } from '../../ConfigProvider/context'
import styles from './index.less'

const FieldItemGroup = ({ fieldsGroup, hideSearchArea }) => {
    return (
        <>
            {fieldsGroup.map(item => {
                return (
                    <React.Fragment key={item.groupKey || item.groupTitle}>
                        <div  className={styles.fieldsGroup}>
                            {
                                item.groupTitle ? <div className={styles.groupTitle}>{item.groupTitle}：</div> : null
                            }
                            <div className={styles.groupContent}>
                                <div className={styles.listWrap}>
                                    <FieldItemList showBtn={false} fieldsList={item.fields} />
                                </div>
                            </div>
                        </div>
                        {
                            item.groupAfterBorder ? <div className={styles.line} /> : null
                        }
                    </React.Fragment>
                )
            })}
            {!hideSearchArea && (
                <div className={styles.searchAreaWrap}>
                    <SearchArea style={{ padding: 0 }} />
                </div>
            )}
        </>
    )
}

const mapStateToProps = (context: ContextValueType) => {
    const {
        form,
        initialValues,
        colNumPerLine,
        sortFields,
        quickSearchPreOptions,
        quickSearchPreSelectDisplay,
        quickSearchOptions,
        quickSearchSelected,
        quickSearchPreOptionsRender,
        deleteQuickSearchConfig,
        addQuickSearchConfig,
        setQuickSearchSelected,
        hideSearchArea
    } = context || {}

    return {
        form,
        initialValues,
        colNumPerLine,
        sortFields,
        quickSearchPreOptions,
        quickSearchPreSelectDisplay,
        quickSearchOptions,
        quickSearchSelected,
        quickSearchPreOptionsRender,
        deleteQuickSearchConfig,
        addQuickSearchConfig,
        setQuickSearchSelected,
        hideSearchArea
    }
}

export default connectProvider(mapStateToProps)(FieldItemGroup, Context)
